<template>
  <v-app id="app">
    <router-view name="header"></router-view>
    <router-view name="notification"></router-view>
    <router-view name="content"></router-view>
    <router-view name="footer"></router-view>
  </v-app>
</template>
<script>
  export default {
    name: 'TFBApp',
    mounted() {
      this.$store.dispatch('app/setVisitor');
    },
  };
</script>
